import { Component } from '@angular/core';
import {
  BackendUploadService,
  ItemProvider,
  ItemView,
  ItemViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { first, of, tap } from 'rxjs';
import { PrimeNGButtonSaveItemActionComponent } from '@ntap/primeng';
import { DynamicFormService } from '@ntap/common';

@Component({
  selector: 'app-save-open-new-podrazina',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class SaveOpenNewPodrazinaComponent extends PrimeNGButtonSaveItemActionComponent {
  constructor(
    itemProvider: ItemProvider,
    itemViewProvider: ItemViewProviderDirective<ItemView>,
    formService: DynamicFormService,
    notificationService: NotificationService,
    backendUploadService: BackendUploadService
  ) {
    super(
      itemProvider,
      itemViewProvider,
      formService,
      notificationService,
      backendUploadService
    );
    this.addSubscription(
      this.itemSaved$.subscribe(() => this.refreshWithNew())
    );
  }

  private refreshWithNew() {
    this.itemViewProvider.item$
      .pipe(
        first(),
        tap((item) => {
          const anyItem = item as any;
          if (
            (anyItem['$parent'] as any)['en~jedinica_gradiva~id'] ==
              anyItem['en~jedinica_gradiva~id'] &&
            anyItem['en~jedinica_gradiva~nadredena_jedinica_gradiva'] != null
          ) {
            // parent je nadredjena od trenutne
            this.itemViewProvider.mergeViewState({
              'en~jedinica_gradiva~id': 0,
              $parentId:
                anyItem['en~jedinica_gradiva~nadredena_jedinica_gradiva'],
              $parent: null
            });
          } else {
            this.itemViewProvider.mergeViewState({
              'en~jedinica_gradiva~id': 0
            });
          }
        })
      )
      .subscribe();
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = of(false);
  }
}
